// extracted by mini-css-extract-plugin
export default {"Container":"Home_Container__weSZN","LatestPatterns":"Home_LatestPatterns__q3xzv","CardLink":"Home_CardLink__j-Gbz"};